export default __webpack_public_path__ + "static/port1-5d898eb562de66db06229fca8f40c79b.jpg";